import { useState, useEffect } from 'react';

import { useAuth, User } from 'oidc-react';

import { clusterApi } from '../api/clusterApi';
import { ClusterStatus, ClusterApp } from '../types/cluster';

export default function useClusters(id: string) {
  const [cluster, setCluster] = useState({} as ClusterStatus);
  const [apps, setApps] = useState(null as null|ClusterApp[]);
  const [loading, setLoading] = useState(true);
  const [kubeconfig, setKubeconfig] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [useOidc, setUseOidc] = useState(true);
  const auth = useAuth();
  const api = clusterApi(auth.userData as User);
  // const [api, setApi] = useState(clusterApi(auth.userData as User));

  // useEffect(() => {
  //   setApi(clusterApi(auth.userData as User));
  // }, [auth.userData?.access_token, auth.userData]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    
    const loadCluster = async () => {
      api.getCluster(id)
        .then(c => {
          setCluster(c);
          setLoading(false);
          setError(null);
        })
        .catch(e => {
          console.error(e);
          setLoading(false);
          if (e.message?.includes('404')) {
            setError('Cluster not found');
            // Stop polling if cluster not found
            if (intervalId) {
              clearInterval(intervalId);
            }
          } else {
            setError('Failed to load cluster');
          }
        });
    };

    loadCluster();
    intervalId = setInterval(loadCluster, 5_000);
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [auth.userData, id]);

  useEffect(() => {
    const loadApps = async () => {
      try {
        setApps(await api.getClusterApps(id));
        setKubeconfig(await api.getKubeconfig(id, useOidc));
      } catch (error) {
        console.error('Error loading apps or kubeconfig:', error);
      }
    };

    loadApps();
    const t = setInterval(loadApps, 5_000);
    return () => {
      clearInterval(t);
    };
  }, [auth.userData, id, useOidc]);

  return {
    loading,
    cluster,
    apps,
    kubeconfig,
    error,
    useOidc,
    setUseOidc,
    deleteCluster: api.deleteCluster,
    refreshCluster: api.refreshCluster,
    getCluster: api.getCluster,
    getClusterApps: api.getClusterApps,
    checkExists: api.checkExists,
    createCluster: api.createCluster,
    listDNS: api.listDNS,
  };
}
